/* Impression SCDM — CLARTE DU CONFIGURATEUR (tache 224), la part vivante.

   CE FICHIER NE CALCULE RIEN ET NE DECIDE RIEN.

   Il ne touche ni au prix, ni au panier, ni au televersement, ni aux modeles,
   ni a la liste des choix obligatoires. Il ne fait que quatre choses, toutes
   d affichage :

   1. IL EXPLIQUE. Un vrai bouton « ? » a cote des intitules techniques, qui
      ouvre une phrase courte sous le titre. Le vernis et la pellicule de
      protection sont deux choses differentes et les clients les confondent
      tout le temps : c est la premiere raison d etre du fichier.

   2. IL DIT CE QUI MANQUE, PRES DU CHAMP. Le message « Il reste a choisir... »
      de scdm-vierge.js reste ou il est, intact, en bas pres du bouton. On
      AJOUTE un rappel a la hauteur du groupe vide. La detection n est PAS
      recodee : on lit le pont en lecture seule que scdm-vierge.js publie
      (window.SCDM_VIERGE), qui rend ses propres manquants() et groupeVisible().
      Si ce pont est absent — vieux cache, fichier pas encore recharge —, ce
      bloc ne fait simplement rien : rien ne casse.

   3. IL MARQUE LES ETAPES TERMINEES. scdm-etapes.js decide, comme avant, quelle
      etape porte la classe « fait ». On ne fait qu ecrire l aria-label qui va
      avec, pour qu un lecteur d ecran entende « terminee » et pas seulement du
      vert. La coche dessinee, elle, est en CSS.

   4. IL RAPPELLE LE TOTAL. Une barre discrete en bas d ecran qui RECOPIE le
      montant deja affiche dans #scdmCmdTotal. Aucun calcul : s il fallait
      recalculer, il y aurait deux verites possibles, et un jour elles se
      contrediraient. Elle se cache des que le bouton « Ajouter a ma commande »
      ou le total lui-meme entre dans l ecran — elle ne peut donc jamais les
      masquer.

   TOUT EST POSE PAR AJOUT. Aucun id, aucun data-*, aucune classe, aucun noeud
   existant n est retire ni renomme. scdm.js reconstruit le contenu de
   #scdmFormes, #scdmMatieres, #scdmFinitions, #scdmLaminages, #scdmQtes et
   #scdmCouleursLettrage a chaque redessin : on n ecrit JAMAIS a l interieur de
   ces conteneurs. Nos ajouts vivent dans le .fld qui les entoure, que personne
   ne reconstruit.

   Charge depuis sections/scdm-configurateur.liquid, en defer, avec sa feuille
   jumelle assets/scdm-configurateur-clarte.css. */

(function () {
  'use strict';

  function texteValidation(cle, repli, params) {
    var racine = document.getElementById('scdmConfigValidationI18n');
    var texte = racine && racine.getAttribute('data-config-validation-' + cle);
    return (texte || repli).replace(/\{([a-z_]+)\}/g, function(mot, nom) {
      return params && Object.prototype.hasOwnProperty.call(params, nom) ? String(params[nom]) : mot;
    });
  }

  function htmlValidation(texte) {
    return String(texte).replace(/[&<>"']/g, function(c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  /* ==================================================================
     LES EXPLICATIONS
     ==================================================================
     Une entree par intitule technique. « hote » est l identifiant du
     conteneur de cases deja pose par la section ou par scdm-panneau.js : on
     remonte de la au .fld, et c est dans le .fld qu on ecrit.

     REGLES D ECRITURE tenues ici — la liste complete, avec les mots interdits
     eux-memes, vit dans claude/vocabulaire-mots-interdits.md, et c est le seul
     endroit ou ils doivent etre ecrits :
     - la presse n est jamais nommee, on ne decrit que ce qu elle sait faire ;
     - on ecrit « predecoupe », « decoupe effleuree », « kiss-cut » ;
     - les deux tournures anglaise et francaise proscrites pour ce meme mode de
       coupe n apparaissent nulle part ;
     - rien qui laisse croire a une certification du produit fini ;
     - AUCUN CHIFFRE qu on ne puisse pas verifier. Les durees de vie exactes
       des vinyles vivent dans MATIERES_TEXTE de scdm-data.js et s affichent
       deja sur la page Materiaux : on ne les recopie pas ici de memoire, on
       decrit l ecart RELATIF, qui, lui, est vrai quelle que soit la revision
       du tableau. */
  var AIDES = [
    {
      cle: 'forme',
      hote: 'scdmFormes',
      nom: 'la forme de découpe',
      html:
        '<p>C’est le <b>contour</b> de la pièce finie : carré, coins arrondis, ' +
        'rond, ou un contour qui suit le dessin.</p>' +
        '<p>Vos autocollants sont <b>prédécoupés</b> : la lame entaille le vinyle ' +
        'sans traverser le papier support (une <b>découpe effleurée</b>, aussi ' +
        'appelée <b>kiss-cut</b>). Le conditionnement dépend du choix ' +
        '« Découpe et présentation ».</p>'
    },
    {
      cle: 'matiere',
      hote: 'scdmMatieres',
      nom: 'le matériau',
      html:
        '<p>Cette rangée décrit le <b>vinyle</b>, pas le panneau : le support ' +
        'rigide est un choix à part, tout en bas.</p>' +
        '<p><b>Vinyle blanc mat</b> — notre standard, compris dans le prix. ' +
        'Surface sourde, aucun reflet : c’est celui qui se lit le mieux de biais ' +
        'et sous un éclairage direct. Rouleau plus étroit que les deux autres.</p>' +
        '<p><b>Vinyle blanc brillant</b> — surface lustrée : les couleurs ' +
        'paraissent plus vives et plus profondes, mais la lumière s’y reflète. ' +
        'C’est celui qui tient le plus longtemps dehors des trois, et il se ' +
        'retire sans laisser de colle.</p>' +
        '<p><b>Vinyle économique</b> — même qualité d’impression que le blanc ' +
        'mat, en rouleau large. C’est le choix quand la pièce est trop large ' +
        'pour le blanc mat, ou quand le travail a une date de fin connue : sa ' +
        'tenue dehors est plus courte que celle du brillant.</p>' +
        '<p>Les détails et usages recommandés sont présentés sur la page ' +
        '<a href="/pages/materiaux">Matériaux</a>.</p>'
    },
    {
      cle: 'finition',
      hote: 'scdmFinitions',
      nom: 'le vernis',
      html:
        '<p>Le vernis est une <b>couche transparente appliquée sur l’impression</b>. ' +
        'Il protège l’encre et fixe l’aspect de la surface.</p>' +
        '<p><b>Mat</b> : surface sourde, presque sans reflet, agréable à lire de ' +
        'près et sous un éclairage direct. <b>Lustré</b> : surface brillante, ' +
        'couleurs plus profondes, mais des reflets selon l’angle.</p>' +
        '<p><b>Ce n’est pas la pellicule de protection.</b> Le vernis est passé ' +
        'sur l’impression même ; la pellicule est un film que l’on déroule ' +
        'par-dessus, au laminateur. Ce sont deux opérations distinctes, et la ' +
        'pellicule a sa propre rangée, plus bas — quand elle est offerte.</p>'
    },
    {
      cle: 'laminage',
      hote: 'scdmLaminages',
      nom: 'la pellicule de protection',
      html:
        '<p>Une <b>pellicule transparente collée par-dessus l’impression</b>, au ' +
        'laminateur. Elle encaisse les égratignures, le lavage à pression et une ' +
        'partie des ultraviolets à la place de votre impression.</p>' +
        '<p><b>Ce n’est pas le vernis.</b> Le vernis est une couche appliquée sur ' +
        'l’impression ; la pellicule est un film ajouté ensuite, dans une passe ' +
        'à part. On peut prendre les deux, l’un, ou aucun des deux.</p>' +
        '<p>Cette rangée <b>n’apparaît que sur les pancartes</b> et les grands ' +
        'formats : sur un petit autocollant, elle reste fermée et rien ne vous ' +
        'est facturé. Elle est <b>facultative</b> — on la coche, on la décoche.</p>'
    },
    {
      cle: 'support',
      hote: 'scdmSupports',
      nom: 'le support rigide',
      html:
        '<p><b>Sans support</b>, vous recevez l’autocollant seul, prêt à poser sur ' +
        'votre propre surface — mur, porte, vitre, panneau que vous avez déjà.</p>' +
        '<p><b>Avec un support</b>, l’autocollant vous arrive déjà posé sur un ' +
        'panneau rigide, coupé à la grandeur. L’aluminium composite est rigide ; ' +
        'le polypropylène cannelé est plus léger.</p>' +
        '<p>Le panneau rigide ne se coupe pas sur mesure : il se vend en ' +
        '<b>grandeurs standards</b>. Si votre visuel n’est pas à l’une d’elles, ' +
        'la rangée qui apparaît sous les supports vous les propose — un clic et ' +
        'la pièce s’y met.</p>'
    }
  ];

  /* Le nom que porte chaque groupe dans le message de manque, quand le pont de
     scdm-vierge.js n en donne pas. Les cles sont celles de scdm-vierge.js. */
  var NOMS_REPLI = {
    format: 'le format',
    forme: 'la forme de découpe',
    matiere: 'le matériau',
    finition: 'le vernis',
    quantite: 'la quantité'
  };

  var COCHE_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="m5 13 4 4 10-10"/></svg>';

  var ouverte = null;      /* la bulle actuellement ouverte, s il y en a une */
  var arme = false;        /* voir « ARME », plus bas */
  var barre = null;
  var barreMt = null;
  var barreVisible = { ajouter: false, total: false };

  function id(x) { return document.getElementById(x); }

  function fldDe(hoteId) {
    var h = id(hoteId);
    if (!h) return null;
    return (h.closest && h.closest('.fld')) || null;
  }

  /* ==================================================================
     1. LES BOUTONS « ? »
     ================================================================== */

  function fermerTout(sauf) {
    document.querySelectorAll('#scdmConfig .scdm-cl-aide[aria-expanded="true"]').forEach(function (b) {
      if (b === sauf) return;
      b.setAttribute('aria-expanded', 'false');
      var c = id(b.getAttribute('aria-controls'));
      if (c) c.hidden = true;
    });
    if (!sauf) ouverte = null;
  }

  function poserAide(a) {
    var fld = fldDe(a.hote);
    if (!fld) return false;
    var label = fld.querySelector(':scope > label');
    if (!label) return false;
    if (label.querySelector('.scdm-cl-aide')) return true;   /* deja pose */

    var idBulle = 'scdmClBulle-' + a.cle;

    var bouton = document.createElement('button');
    bouton.type = 'button';
    bouton.className = 'scdm-cl-aide';
    bouton.setAttribute('aria-expanded', 'false');
    bouton.setAttribute('aria-controls', idBulle);
    bouton.innerHTML = '<span class="r" aria-hidden="true">?</span>' +
      '<span class="scdm-cl-vh">' + htmlValidation(texteValidation('explanation', 'Explication : {name}', { name: texteValidation('group_' + a.cle, a.nom) })) + '</span>';

    var bulle = document.createElement('div');
    bulle.className = 'scdm-cl-bulle';
    bulle.id = idBulle;
    bulle.hidden = true;
    bulle.innerHTML = texteValidation('help_' + a.cle + '_html', a.html, { materials_url: htmlValidation(texteValidation('materials_url', '/pages/materiaux')) });

    /* Un <label> ne doit contenir qu un seul controle : le bouton y est
       accepte, mais on garde la bulle DEHORS, juste apres le titre.
       Le bouton se range AVANT la pastille « Fait », quel que soit celui des
       deux qui a ete pose en premier : le titre se lit toujours
       « Materiau  ?  ........  FAIT ». */
    var coche = label.querySelector('.scdm-cl-coche');
    if (coche) label.insertBefore(bouton, coche);
    else label.appendChild(bouton);

    if (label.nextSibling) fld.insertBefore(bulle, label.nextSibling);
    else fld.appendChild(bulle);

    /* Le clic sur un <label> for="..." donne le foyer au champ vise : sans
       preventDefault, ouvrir l explication du format ouvrirait aussi la liste
       deroulante. On arrete aussi la propagation pour que le clic ne soit pas
       relu comme un « clic exterieur » par le detecteur ci-dessous. */
    bouton.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var ouvert = bouton.getAttribute('aria-expanded') === 'true';
      fermerTout(ouvert ? null : bouton);
      bouton.setAttribute('aria-expanded', ouvert ? 'false' : 'true');
      bulle.hidden = ouvert;
      ouverte = ouvert ? null : bouton;
    });

    return true;
  }

  /* On ne retient AUCUN drapeau « c est fait » : poserAide() sort tout de
     suite quand le bouton est deja la, et si un autre fichier reconstruisait
     un jour la rangee des supports, le bouton se reposerait tout seul. */
  function poserAides() {
    AIDES.forEach(function (a) { poserAide(a); });
  }

  function ecouterFermeture() {
    /* A l Echap. */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.keyCode !== 27) return;
      if (!ouverte) return;
      var b = ouverte;
      fermerTout(null);
      if (b.focus) b.focus();
    });
    /* Au clic exterieur — n importe ou hors de la bulle ouverte. */
    document.addEventListener('click', function (e) {
      if (!ouverte) return;
      var bulle = id(ouverte.getAttribute('aria-controls'));
      if (bulle && e.target && bulle.contains(e.target)) return;
      fermerTout(null);
    });
  }

  /* ==================================================================
     2. CE QUI MANQUE, DIT PRES DU CHAMP
     ==================================================================
     ARME. On n allume pas ces marqueurs au chargement. Sur une page vierge,
     les cinq choix obligatoires manquent tous : cinq encadres orange d un
     coup, ce serait une alarme, pas une aide — et ce serait faux, le client
     n a encore rien eu l occasion de faire.

     Ils s allument au premier des deux signes suivants :
       - le client a fait au moins un choix (la liste des manquants a diminue) ;
       - le client a clique « Ajouter a ma commande » sans avoir tout rempli.
     A partir de la, ils restent : c est le moment ou ils aident vraiment. */

  function pont() {
    var p = window.SCDM_VIERGE;
    if (!p || typeof p.manquantsCles !== 'function' || typeof p.groupes !== 'function') return null;
    return p;
  }

  function marqueurDe(fld) {
    var m = fld.querySelector(':scope > .scdm-cl-manque');
    if (m) return m;
    m = document.createElement('p');
    m.className = 'scdm-cl-manque';
    m.hidden = true;
    fld.appendChild(m);
    return m;
  }

  function cocheDe(fld) {
    var label = fld.querySelector(':scope > label');
    if (!label) return null;
    var c = label.querySelector('.scdm-cl-coche');
    if (c) return c;
    c = document.createElement('span');
    c.className = 'scdm-cl-coche';
    c.innerHTML = COCHE_SVG + '<span>' + htmlValidation(texteValidation('done', 'Fait')) + '</span>';
    /* TOUJOURS EN DERNIER, jamais avant le bouton « ? ». La pastille est
       poussee a droite par margin-left:auto : posee avant le bouton, elle
       aurait entraine le bouton avec elle, et le « ? » aurait saute d un bout
       a l autre du titre chaque fois que le groupe se remplit. */
    label.appendChild(c);
    return c;
  }

  var dernierEtat = '';
  var dernierNb = -1;

  function peindreManques() {
    var p = pont();
    if (!p) return;

    var manquants = p.manquantsCles();
    var groupes = p.groupes();

    if (dernierNb >= 0 && manquants.length < dernierNb) arme = true;
    dernierNb = manquants.length;

    var etat = (arme ? '1' : '0') + '|' + manquants.join(',');
    if (etat === dernierEtat) return;
    dernierEtat = etat;

    groupes.forEach(function (g) {
      var fld = fldDe(g.hote);
      if (!fld) return;
      var manque = manquants.indexOf(g.cle) >= 0;
      var visible = (typeof p.groupeVisible === 'function') ? p.groupeVisible(g.cle) : true;
      var nom = g.nom || (NOMS_REPLI[g.cle] && texteValidation('group_' + g.cle, NOMS_REPLI[g.cle])) || texteValidation('this_choice', 'ce choix');

      /* La pastille « Fait » : le groupe est visible et n est plus reclame. */
      cocheDe(fld);
      fld.classList.toggle('scdm-cl-fait', visible && !manque);

      var reclame = arme && manque && visible;
      fld.classList.toggle('scdm-cl-reclame', reclame);

      var m = marqueurDe(fld);
      if (reclame) {
        var txt = texteValidation('choose_one', 'Il reste à choisir {choice}.', { choice: nom });
        if (m.textContent !== txt) m.textContent = txt;
        m.hidden = false;
      } else {
        m.hidden = true;
      }
    });
  }

  /* POURQUOI SUR document ET EN CAPTURE, et pas sur le bouton lui-meme.
     Quand il manque un choix, scdm-vierge.js intercepte le clic sur
     #scdmAjouter en capture ET appelle stopImmediatePropagation() : plus aucun
     ecouteur pose sur le bouton ne s execute, ni en capture ni en bulle. La
     capture sur document, elle, passe AVANT le bouton, donc avant lui, quel
     que soit l ordre de chargement des fichiers.
     On n appelle ni preventDefault ni stopPropagation : on regarde passer. */
  function armerAuClic() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest || !t.closest('#scdmAjouter')) return;
      var p = pont();
      if (!p || !p.manquantsCles().length) return;
      arme = true;
      dernierEtat = '';
      setTimeout(peindreManques, 0);
    }, true);
  }

  /* ==================================================================
     3. LES ETAPES TERMINEES, DITES AUTREMENT QUE PAR LA COULEUR
     ==================================================================
     La coche dessinee est en CSS. Ici on ne pose que le nom accessible : sans
     lui, un lecteur d ecran lit « 3 Materiau » pour une etape faite comme pour
     une etape a faire. On n ecrit JAMAIS dans la classe des <li> : c est
     scdm-etapes.js qui en decide, et lui seul. */

  function peindreFil() {
    var fil = id('scdmFil');
    if (!fil) return;
    var lis = fil.querySelectorAll('li');
    for (var i = 0; i < lis.length; i++) {
      var li = lis[i];
      var pas = li.querySelector('.pas');
      if (!pas) continue;
      var titre = (pas.textContent || '').replace(/\s+/g, ' ').trim();
      /* Le numero est dans le <b> en tete : « 3 Materiau » se lit deja bien. */
      var etat = li.classList.contains('fait') ? texteValidation('step_done', 'étape terminée')
               : (li.classList.contains('actif') ? texteValidation('step_current', 'étape en cours') : texteValidation('step_next', 'étape à faire'));
      var lbl = titre + ' — ' + etat;
      if (li.getAttribute('aria-label') !== lbl) li.setAttribute('aria-label', lbl);
    }
  }

  function suivreFil() {
    var fil = id('scdmFil');
    if (!fil || !window.MutationObserver) return;
    new MutationObserver(peindreFil).observe(fil, {
      subtree: true, attributes: true, attributeFilter: ['class']
    });
    peindreFil();
  }

  /* ==================================================================
     4. LA BARRE DU TOTAL
     ==================================================================
     ELLE RECOPIE. #scdmCmdTotal est ecrit par scdm.js : on lit son texte, on
     l ecrit ici. Aucun calcul, donc aucune facon de se contredire.

     Elle ne s affiche que si « Ma commande » existe vraiment (au moins un
     design ajoute — sinon le total vaut zero et la barre ne dit rien), et
     seulement quand le bouton d ajout ET le total sont tous les deux hors de
     l ecran. C est ce qui garantit qu elle n obstrue jamais le bouton
     « Ajouter a ma commande ».

     aria-hidden : le montant est deja dans la page, annonce par le
     recapitulatif. Le repeter ferait entendre deux fois la meme somme. */

  function poserBarre() {
    if (barre) return true;
    var section = id('configurateur');
    var hote = section && section.parentNode;   /* le .scdm de la section */
    if (!hote) return false;
    barre = document.createElement('div');
    barre.className = 'scdm-cl-barre';
    barre.id = 'scdmClBarre';
    barre.hidden = true;
    barre.setAttribute('aria-hidden', 'true');
    barre.innerHTML = '<span class="e">' + htmlValidation(texteValidation('total_before_tax', 'Total avant taxes')) + '</span>' +
      '<strong class="m" id="scdmClBarreMt">0,00 $</strong>';
    hote.appendChild(barre);
    barreMt = id('scdmClBarreMt');
    return true;
  }

  function peindreBarre() {
    if (!barre && !poserBarre()) return;
    var cmd = id('scdmCommande');
    var tot = id('scdmCmdTotal');
    var vivant = !!(cmd && !cmd.hidden && tot);
    var montre = vivant && !barreVisible.ajouter && !barreVisible.total;

    if (montre && tot) {
      var t = (tot.textContent || '').trim();
      if (t && barreMt && barreMt.textContent !== t) barreMt.textContent = t;
    }
    if (montre) {
      if (barre.hidden) { barre.hidden = false; }
      /* Un souffle avant la transition, sinon le navigateur peint deja la
         barre en place et l animation ne se voit pas. */
      if (!barre.classList.contains('on')) {
        requestAnimationFrame(function () { barre.classList.add('on'); });
      }
    } else {
      barre.classList.remove('on');
      if (!barre.hidden) barre.hidden = true;
    }
  }

  function suivreBarre() {
    if (!window.IntersectionObserver) return;   /* pas de barre, pas de risque */
    var o = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.target.id === 'scdmAjouter') barreVisible.ajouter = e.isIntersecting;
        if (e.target.id === 'scdmCmdTotal') barreVisible.total = e.isIntersecting;
      });
      peindreBarre();
    }, { root: null, threshold: 0 });
    var a = id('scdmAjouter'), t = id('scdmCmdTotal');
    if (a) o.observe(a);
    if (t) o.observe(t);
  }

  /* ==================================================================
     DEMARRAGE
     ================================================================== */

  function demarrer() {
    if (!id('scdmConfig')) return;

    poserAides();
    ecouterFermeture();
    armerAuClic();
    suivreFil();
    poserBarre();
    suivreBarre();

    /* La rangee du support rigide est posee PLUS TARD par scdm-panneau.js, et
       les rangees conditionnelles apparaissent et disparaissent sous le
       client. On repasse donc, sans rien reconstruire : poserAide() sort tout
       de suite si le bouton est deja la. Quatre fois par seconde, comme le
       filet de scdm-vierge.js — c est assez pour que ca paraisse instantane et
       assez peu pour ne rien couter. */
    setInterval(function () {
      poserAides();
      peindreManques();
      peindreBarre();
    }, 250);

    peindreManques();
    peindreBarre();
  }

  /* On attend le pont de scdm-vierge.js, qui attend lui-meme window.SCDM. Au
     bout d une dizaine de secondes on demarre quand meme : les explications,
     le fil et la barre ne dependent pas de lui, et il vaut mieux un
     configurateur explique sans marqueurs de manque que rien du tout. */
  function quandPret(n) {
    if (id('scdmConfig') && (pont() || (n || 0) > 80)) return demarrer();
    if ((n || 0) > 200) return;
    setTimeout(function () { quandPret((n || 0) + 1); }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { quandPret(0); });
  } else {
    quandPret(0);
  }
})();
